<template>
  <!-- Single download -->
  <div
    v-if="items?.length === 1"
    :class="[joinClasses('single-download', modifiers), 'typo-small']"
  >
    <a
      :href="items[0].path"
      :target="items[0].target"
    >
      <div class="single-download__button">
        <span>{{ items[0].label }}</span>
        <PushDown />
      </div>
    </a>
  </div>

  <!-- Multi download -->
  <Dropdown
    v-if="items?.length > 1"
    :class="joinClasses('multi-download', modifiers)"
    :items="items"
    placement="bottom-end"
    @open="trigger"
  >
    <button
      class="multi-download__button"
      type="button"
    >
      <span class="typo-small">
        {{ label }}
      </span>
      <div
        :class="{ select__arrow: true, 'select__arrow--active': open }"
      >
        <UseSvg
          class="icon icon--small"
          name="arrow_down_16"
        />
      </div>
    </button>
  </Dropdown>
</template>

<script setup>
import { ref } from 'vue';
import joinClasses from '@/functions/join_classes';

// Components
import Dropdown from '@/components/generic/dropdown.vue';

// Icons
import UseSvg from '@/components/generic/use_svg.vue';
import PushDown from '@/images/push-down.svg';

defineProps({
  /** The items to be iterated over. Format: [{ label: 'label', path: 'path', target: '_blank' }] */
  items: { type: Array, required: true },
  /** Dropdown label if there are multiple links */
  label: { type: String, default: '', required: false },
  /** Additional classes you may add */
  modifiers: { type: Array, default: () => [] },
});

const open = ref(false);

function trigger(value) {
  open.value = value;
}
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

@mixin right-border-style {
  border-right: 1px solid map-get($foreground-color, darker);
  padding-right: bu(1.5);
}

@mixin left-border-style {
  border-left: 1px solid map-get($foreground-color, darker);
  padding-left: bu(1.5);
}

@mixin right-margin-style {
  margin-right: bu(1.5);
}

@mixin left-margin-style {
  margin-left: bu(1.5);
}

.single-download {
  padding-left: bu(1);
  font-weight: 400;

  &--right-border {
    @include right-border-style;
  }

  &--left-border {
    @include left-border-style;
  }

  &--margin-left {
    @include left-margin-style;
  }

  &--margin-right {
    @include right-margin-style;
  }

  &__button {
    display: flex;
    align-items: center;

    span {
      padding-right: bu(1);
    }
  }

  &--hide {
    display: none;
  }
}

.multi-download {
  &--right-border {
    @include right-border-style;
  }

  &--left-border {
    @include left-border-style;
  }

  &--margin-left {
    @include left-margin-style;
  }

  &--margin-right {
    @include right-margin-style;
  }

  &__button {
    align-items: center;
    display: flex;

    span {
      margin-right: bu(0.5);

      @include breakpoint(large) {
        margin-right: bu(1.5);
      }
    }
  }
}
</style>
